import { merge } from 'lodash';

import * as envConfigModule from '../../flavours/elret/config';
import commonConfigModule from '../../flavours/elret/config/config';

const FLAVOUR = import.meta.env.VITE_FLAVOUR || 'elret';
const TARGET_ENV = import.meta.env.VITE_TARGET_ENV || 'prod';

// eslint-disable-next-line
console.log(`loading ${FLAVOUR}/${TARGET_ENV} in ${import.meta.env.VITE_NODE_ENV || 'prod'} mode`);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const envConfig = envConfigModule[TARGET_ENV];
export default merge(commonConfigModule, envConfig);
